import { Navigate } from 'react-router-dom-v5-compat'

import { useAuth0 } from '@sparkai/auth'
import { LoadingMessage } from '@sparkai/auth/src/components/LoadingMessage'

export function Fallback() {
  const { isAuthenticated } = useAuth0()

  const { hash, pathname, search } = globalThis.location
  const returnTo = pathname !== '/' ? `${pathname}${search}${hash}` : undefined

  if (isAuthenticated) {
    return <Navigate to='/redirect' replace state={returnTo ? { returnTo } : undefined} />
  }

  return <LoadingMessage />
}
